// Messages notifications.
export const ADD_MESSAGE_SUCCESS = 'New inspiration added successfully!';
export const ADD_MESSAGE_FAIL = "The inspiration couldn't be added.";

export const UPDATE_MESSAGE_SUCCESS =
  'The inspiration was updated successfully!';
export const UPDATE_MESSAGE_FAIL = "The inspiration couldn't be updated";

export const REMOVE_MESSAGE_SUCCESS =
  'The inspiration was deleted successfully!';
export const REMOVE_MESSAGE_FAIL = "The inspiration couldn't be deleted";

export const CANCEL_MESSAGE_CONFIRMATION_TITLE = 'Cancel inspiration?';
export const CANCEL_MESSAGE_CONFIRMATION_BODY =
  "Are you sure you want to cancel this inspiration? You will lose any inspiration data you've added. This action cannot be undone.";

export const REMOVE_MESSAGE_CONFIRMATION_TITLE = 'Delete inspiration?';
export const REMOVE_MESSAGE_CONFIRMATION_BODY =
  'Are you sure you want to delete this inspiration? This action cannot be undone.';

// Programs notifications.
export const ADD_PROGRAM_SUCCESS = 'New program added successfully!';
export const ADD_PROGRAM_FAIL = "The program couldn't be added.";

export const UPDATE_PROGRAM_SUCCESS = 'The program was updated successfully!';
export const UPDATE_PROGRAM_FAIL = "The program couldn't be updated";

export const REMOVE_PROGRAM_SUCCESS = 'The program was deleted successfully!';
export const REMOVE_PROGRAM_FAIL = "The program couldn't be deleted";

export const CANCEL_PROGRAM_CONFIRMATION_TITLE = 'Cancel Program?';
export const CANCEL_PROGRAM_CONFIRMATION_BODY =
  "Are you sure you want to cancel this program? You will lose any program data you've added. This action cannot be undone.";

export const REMOVE_PROGRAM_CONFIRMATION_TITLE = 'Delete Program?';
export const REMOVE_PROGRAM_CONFIRMATION_BODY =
  'Are you sure you want to delete this program? This action cannot be undone.';
